module.exports = __webpack_public_path__ + "img/mapping.1d1badb7.png";